import React from 'react';
import { TopNavigationBar } from '@/components/ui/Navigation/TopNavigationBar';
import { LeftNavigationBar } from '@/components/ui/Navigation/LeftNavigationBar';

export const DashboardPreview: React.FC = () => {
  return (
    <div className="relative min-h-screen bg-[#f1f3f5]">
      {/* Fixed Navigation Bars */}
      <TopNavigationBar />
      <LeftNavigationBar currentPath="/dashboard" />
      
      {/* Main Content Area with proper spacing */}
      <div className="relative">
        {/* Spacer for fixed navigation */}
        <div style={{ height: '64px' }} />
        
        {/* Content container */}
        <div 
          className="transition-all duration-300"
          style={{
            marginLeft: '72px',
            minHeight: 'calc(100vh - 64px)',
            backgroundColor: '#f1f3f5',
            padding: '2rem'
          }}
        >
          {/* Empty Dashboard Content */}
          <div style={{
            height: '100%',
            minHeight: '400px'
          }} />
        </div>
      </div>
    </div>
  );
};